import React, { useState } from 'react';
import qs from 'qs';
import { locationT } from '@ordermentum/ui-types';
import { safeRedirect } from '@ordermentum/ui-shared/helpers/urls';
import axios from 'axios';
import { PasswordEntryForm } from './Forms/PasswordEntryForm';
import { LoginBase } from './LoginBase';
import { Header } from './DefaultLogin';

export const DefaultPasswordSignUpEntry = (props: { location: locationT }) => {
  const queryStrings = qs.parse(props.location.search, {
    ignoreQueryPrefix: true,
  });
  const {
    password_reset_token: passwordResetToken,
    source,
    destination,
  } = queryStrings;

  const [error, setError] = useState<string | undefined>();

  const onSubmit = async (password: string) => {
    setError(undefined);
    const query = qs.stringify({
      source,
      destination,
      password_reset_token: passwordResetToken,
    });
    try {
      const res = await axios.post(`/user/password/create?${query}`, {
        password,
      });
      window.location.href = safeRedirect(res.data.destination, '/');
      return true;
    } catch (e) {
      setError(`Something went wrong submitting your password: ${e.message}`);
      return false;
    }
  };

  return (
    <LoginBase type="default" header={<Header />}>
      <PasswordEntryForm onSubmit={onSubmit} error={error} />
    </LoginBase>
  );
};
